import { useContext } from 'react'
import { SelectAndLinkContext } from './SelectAndLinkContextRef'

export function useSelectAndLink() {
  const context = useContext(SelectAndLinkContext)

  if (context === null) {
    throw new Error(
      'useSelectAndLink must be used within a SelectAndLinkProvider'
    )
  }

  return context
}
